// Statik (backend'siz) çalışmak için Hostinger PHP proxy üzerinden veri çekiyoruz.
// /proxy.php dosyası finans.truncgil.com mirror'ından veri çeker (Harem Altın canlı verisi).

const PROXY_ENDPOINTS = [
  "/proxy.php",
  "/api/market",
];

const CURRENCY_META = {
  USD: { name: "ABD Doları", flag: "🇺🇸" },
  EUR: { name: "Euro", flag: "🇪🇺" },
  GBP: { name: "İngiliz Sterlini", flag: "🇬🇧" },
  CHF: { name: "İsviçre Frangı", flag: "🇨🇭" },
  JPY: { name: "Japon Yeni", flag: "🇯🇵" },
  CAD: { name: "Kanada Doları", flag: "🇨🇦" },
  AUD: { name: "Avustralya Doları", flag: "🇦🇺" },
  SEK: { name: "İsveç Kronu", flag: "🇸🇪" },
  NOK: { name: "Norveç Kronu", flag: "🇳🇴" },
  DKK: { name: "Danimarka Kronu", flag: "🇩🇰" },
  SAR: { name: "Suudi Arabistan Riyali", flag: "🇸🇦" },
  RUB: { name: "Rus Rublesi", flag: "🇷🇺" },
  AED: { name: "BAE Dirhemi", flag: "🇦🇪" },
  BGN: { name: "Bulgar Levası", flag: "🇧🇬" },
  RON: { name: "Rumen Leyi", flag: "🇷🇴" },
  CNY: { name: "Çin Yuanı", flag: "🇨🇳" },
  KWD: { name: "Kuveyt Dinarı", flag: "🇰🇼" },
  QAR: { name: "Katar Riyali", flag: "🇶🇦" },
  AZN: { name: "Azerbaycan Manatı", flag: "🇦🇿" },
  ILS: { name: "İsrail Şekeli", flag: "🇮🇱" },
};

const PRIORITY = ["USD", "EUR", "GBP", "CHF", "JPY", "CAD", "AUD"];

const GOLD_META = [
  { key: "gram-altin", code: "GRAM", name: "Gram Altın" },
  { key: "ceyrek-altin", code: "CEYREK", name: "Çeyrek Altın" },
  { key: "yarim-altin", code: "YARIM", name: "Yarım Altın" },
  { key: "tam-altin", code: "TAM", name: "Tam Altın" },
  { key: "cumhuriyet-altini", code: "CUMHURIYET", name: "Cumhuriyet Altını" },
  { key: "ata-altin", code: "ATA", name: "Ata Lirası" },
  { key: "resat-altin", code: "RESAT", name: "Reşat Altın" },
  { key: "hamit-altin", code: "HAMIT", name: "Hamit Altın" },
  { key: "ikibucuk-altin", code: "IKIBUCUK", name: "İkibuçuk Altın" },
  { key: "besli-altin", code: "BESLI", name: "Beşli Altın" },
  { key: "gremse-altin", code: "GREMSE", name: "Gremse Altın" },
  { key: "14-ayar-altin", code: "14AYAR", name: "14 Ayar Altın" },
  { key: "18-ayar-altin", code: "18AYAR", name: "18 Ayar Altın" },
  { key: "22-ayar-bilezik", code: "22AYAR", name: "22 Ayar Bilezik" },
  { key: "gumus", code: "GUMUS", name: "Gümüş" },
];

const CACHE_KEY = "akaydin_market_cache_v5";
const CACHE_TTL = 3 * 60 * 1000; // 3 minutes

function readCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (Date.now() - obj.t > CACHE_TTL) return null;
    return obj.d;
  } catch {
    return null;
  }
}

function writeCache(data) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: data }));
  } catch {}
}

function parseNum(v) {
  if (v === null || v === undefined) return null;
  const cleaned = String(v).replace(/[$\s]/g, "").replace(/\./g, "").replace(",", ".");
  const n = parseFloat(cleaned);
  return Number.isNaN(n) ? null : n;
}

function parseChange(v) {
  if (!v) return null;
  const cleaned = String(v).replace("%", "").replace(",", ".").trim();
  const n = parseFloat(cleaned);
  return Number.isNaN(n) ? null : n;
}

async function fetchFromEndpoint(endpoint) {
  // Backend endpoint için tam URL (preview ortamında çalışsın)
  const url =
    endpoint.startsWith("/api/") && process.env.REACT_APP_BACKEND_URL
      ? `${process.env.REACT_APP_BACKEND_URL}${endpoint}`
      : endpoint;
  const res = await fetch(url, { signal: AbortSignal.timeout(10000) });
  if (!res.ok) throw new Error("HTTP " + res.status);
  const text = await res.text();
  const data = JSON.parse(text);
  if (data.error) throw new Error(data.error);
  return data;
}

async function fetchSourceJson() {
  let lastErr = null;
  for (const ep of PROXY_ENDPOINTS) {
    try {
      const data = await fetchFromEndpoint(ep);
      if (data && typeof data === "object" && data.USD) return data;
    } catch (e) {
      lastErr = e;
    }
  }
  throw lastErr || new Error("Veri kaynağına ulaşılamadı");
}

async function fetchAll() {
  const cached = readCache();
  if (cached) return cached;

  const raw = await fetchSourceJson();
  const updateDate = raw.Update_Date || new Date().toLocaleString("tr-TR");

  const rates = [];
  for (const code of Object.keys(CURRENCY_META)) {
    const row = raw[code];
    if (!row) continue;
    rates.push({
      code,
      name: CURRENCY_META[code].name,
      flag: CURRENCY_META[code].flag,
      unit: 1,
      forex_buying: parseNum(row["Alış"]),
      forex_selling: parseNum(row["Satış"]),
      banknote_buying: parseNum(row["Alış"]),
      banknote_selling: parseNum(row["Satış"]),
      change: parseChange(row["Değişim"]),
    });
  }
  rates.sort((a, b) => {
    const pa = PRIORITY.indexOf(a.code);
    const pb = PRIORITY.indexOf(b.code);
    return (pa < 0 ? 999 : pa) - (pb < 0 ? 999 : pb);
  });

  const goldItems = [];
  for (const g of GOLD_META) {
    const row = raw[g.key];
    if (!row) continue;
    goldItems.push({
      code: g.code,
      name: g.name,
      buy: parseNum(row["Alış"]),
      sell: parseNum(row["Satış"]),
      change: parseChange(row["Değişim"]),
    });
  }

  const payload = {
    updated: updateDate,
    rates: {
      date: updateDate,
      bulletin_no: null,
      rates,
      source: "Anlık Piyasa Verileri",
    },
    gold: {
      date: updateDate,
      items: goldItems,
      source: "Anlık Piyasa Verileri",
    },
  };
  writeCache(payload);
  return payload;
}

export async function fetchRates() {
  try {
    const all = await fetchAll();
    return all.rates;
  } catch (e) {
    return {
      date: new Date().toLocaleString("tr-TR"),
      bulletin_no: null,
      rates: [],
      source: "Veri kaynağına ulaşılamadı",
    };
  }
}

export async function fetchGold() {
  try {
    const all = await fetchAll();
    return all.gold;
  } catch (e) {
    return {
      date: new Date().toLocaleString("tr-TR"),
      items: [],
      source: "Veri kaynağına ulaşılamadı",
    };
  }
}

export async function submitContact(payload) {
  const accessKey = process.env.REACT_APP_WEB3FORMS_KEY;
  if (!accessKey || accessKey === "YOUR_WEB3FORMS_KEY") {
    throw new Error(
      "İletişim formu henüz aktif değil. Lütfen +90 226 811 29 50 numaralı telefondan ulaşın.",
    );
  }
  const fd = new FormData();
  fd.append("access_key", accessKey);
  fd.append("from_name", "Akaydın Döviz Web");
  fd.append("subject", payload.subject || "Akaydın Döviz - İletişim Formu");
  fd.append("name", payload.name);
  fd.append("email", payload.email);
  fd.append("phone", payload.phone || "-");
  fd.append("message", payload.message);
  fd.append("botcheck", "");

  const res = await fetch("https://api.web3forms.com/submit", {
    method: "POST",
    body: fd,
  });
  const data = await res.json();
  if (!res.ok || !data.success) {
    throw new Error(data.message || "Mesaj gönderilemedi.");
  }
  return { id: data.data?.id || "ok", created_at: new Date().toISOString() };
}

export const formatTRY = (n, decimals = 4) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString("tr-TR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const formatNum = (n, decimals = 2) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString("tr-TR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};
